import * as React from 'react'

const FormatPrice = ({
	price,
	currency,
}: {
	price: number
	currency: string
}) => {
	const currencySymbol = (() => {
		switch (currency) {
			case 'USD':
				return '$'
			case 'GBP':
				return '£'
			case 'EUR':
				return '€'
			default:
				return currency + ' '
		}
	})()
	return (
		<>
			{currencySymbol} {price.toLocaleString()}
		</>
	)
}

export default FormatPrice
